import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Content from './Content'
import PageHeader from './PageHeader'

const AboutPageTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content

  return (
    <div>
      {/* Enhanced Page Header */}
      <PageHeader
        title={title}
        subtitle="Driving sustainable development through community empowerment and environmental stewardship"
        backgroundImage="/img/greenView.jpg"
      />

      {/* Mission Statement Section */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-10-tablet is-8-desktop is-6-widescreen">
              <div className="has-text-centered mb-6">
                <h2 className="title is-2-desktop is-3-tablet is-4-mobile has-text-primary mb-4">
                  Our Mission
                </h2>
                <p className="subtitle is-4-desktop is-5-tablet is-6-mobile about-subtitle">
                  Green Innovative Research Center Nepal (GIRC Nepal) is dedicated to fostering sustainable development
                  through innovative research, community engagement, and environmental conservation initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile about-section-bg">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-10-tablet is-10-desktop is-8-widescreen">
              <div className="has-text-centered mb-6">
                <h2 className="title is-2-desktop is-3-tablet is-4-mobile mb-4">
                  Our Core Values
                </h2>
                <p className="subtitle is-5-desktop is-6-mobile about-subtitle">
                  These principles guide everything we do
                </p>
              </div>

              {/* Values Grid */}
              <div className="columns is-multiline is-variable is-8-desktop is-4-tablet is-2-mobile">
                
                {/* Local Development */}
                <div className="column is-6-desktop is-full-mobile">
                  <div className="card feature-card-enhanced hover-lift">
                    <div className="card-content">
                      <div className="has-text-centered mb-4">
                        <span className="icon is-large has-text-primary">
                          <i className="fas fa-users fa-2x"></i>
                        </span>
                      </div>
                      <h3 className="title is-5-desktop is-6-mobile has-text-centered mb-3">
                        Local Development
                      </h3>
                      <p className="about-card-text">
                        Assisting & facilitating the local people for their self motivated development
                        effort, promotion and adoption of optimum utilization of natural resources for the
                        sustainable development, development of local human resources through the
                        appropriate training, counseling, seminars, exposure tour etc.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Stakeholder Relations */}
                <div className="column is-6-desktop is-full-mobile">
                  <div className="card feature-card-enhanced hover-lift">
                    <div className="card-content">
                      <div className="has-text-centered mb-4">
                        <span className="icon is-large has-text-primary">
                          <i className="fas fa-handshake fa-2x"></i>
                        </span>
                      </div>
                      <h3 className="title is-5-desktop is-6-mobile has-text-centered mb-3">
                        Stakeholder Relations
                      </h3>
                      <p className="about-card-text">
                        Promotion and strengthening of Community Organizations thorough development
                        of co-ordination and linkage among the line agencies such as; municipalities,
                        governmental departments, Water Resources and Irrigation Divisions & forest and
                        climate divisions and other stakeholders working in the field of development.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Community Programs */}
                <div className="column is-6-desktop is-full-mobile">
                  <div className="card feature-card-enhanced hover-lift">
                    <div className="card-content">
                      <div className="has-text-centered mb-4">
                        <span className="icon is-large has-text-primary">
                          <i className="fas fa-leaf fa-2x"></i>
                        </span>
                      </div>
                      <h3 className="title is-5-desktop is-6-mobile has-text-centered mb-3">
                        Community Programs
                      </h3>
                      <p className="about-card-text">
                        Enhance the resistance capacity of community thereby developing more resilient
                        infrastructure by differential activities such as; Commercial Agricultural
                        Production & Marketing, Environmental protection & management, Water
                        Sanitation & Hygiene (WASH), Gender & Social Inclusion.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Women and Children Health */}
                <div className="column is-6-desktop is-full-mobile">
                  <div className="card feature-card-enhanced hover-lift">
                    <div className="card-content">
                      <div className="has-text-centered mb-4">
                        <span className="icon is-large has-text-primary">
                          <i className="fas fa-heart fa-2x"></i>
                        </span>
                      </div>
                      <h3 className="title is-5-desktop is-6-mobile has-text-centered mb-3">
                        Women & Children Health
                      </h3>
                      <p className="about-card-text">
                        Enhance the health status of the women and children through improved nutritional
                        facility, good health practice & health seeking behavior.
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technology & Innovation Section */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-10-tablet is-8-desktop is-6-widescreen">
              <div className="box main-pitch-section has-text-centered">
                <div className="has-text-centered mb-5">
                  <span className="icon is-large has-text-primary mb-3">
                    <i className="fas fa-cogs fa-3x"></i>
                  </span>
                </div>
                <h2 className="title is-3-desktop is-4-tablet is-5-mobile mb-4">
                  Technology & Innovation
                </h2>
                <p className="subtitle is-5-desktop is-6-mobile about-tech-text">
                  Adoption of Integrated approach for development process including promoting advancement of
                  technology and providing local and international technology solutions and software consulting.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile has-background-primary">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-8-tablet is-6-desktop has-text-centered">
              <h2 className="title is-3-desktop is-4-tablet is-5-mobile has-text-white mb-4">
                Ready to Make a Difference?
              </h2>
              <p className="subtitle is-5-desktop is-6-mobile has-text-white-ter mb-5">
                Join us in our mission to create sustainable environmental solutions for Nepal and beyond.
              </p>
              <div className="buttons is-centered">
                <a href="/contact" className="button is-white is-large-desktop is-medium-tablet btn-primary-animated">
                  <span className="icon">
                    <i className="fas fa-envelope"></i>
                  </span>
                  <span>Get In Touch</span>
                </a>
                <a href="/products" className="button is-outlined is-white is-large-desktop is-medium-tablet btn-outline-animated">
                  <span className="icon">
                    <i className="fas fa-leaf"></i>
                  </span>
                  <span>Our Services</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

AboutPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

export default AboutPageTemplate
